import PropTypes from 'prop-types'

const propTypes = {
  content: PropTypes.object,
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default propTypes
